<div class="flex flex-nowrap items-center w-full h-full">
  @if (shouldShowFormulaEditor$ | async) {
    @defer (on viewport) {
      <blaze-cm-formula-editor
        [useAppTheme]="useAppTheme"
        [config]="config"
        [initialHeight]="initialHeight()"
        [colorMarkdown]="colorMarkdown"
        [errors]="internalErrors()"
        (formulaChanged)="onFormulaChange($event)"
      />
    } @placeholder {
      <div></div>
    }
  }
</div>
